import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { isSharedIdentificationFeatureEnabled } from 'constant';
import { OFFER_STATUS } from 'utils';

import { markMainMember } from '../main-member';

import EmptyState from './empty-state';
import SortableItem from './sortable-item';

/**
 * @param {Object} props
 * @param {Array} props.fields - Form.List fields
 * @param {{ remove: Function, move: Function }} props.operations - Form.List operations
 * @param {Object} props.form - Antd Form instance (field değerlerini okumak için)
 * @param {boolean} [props.readOnly=false] - readOnly modda drag handle ve sil butonu gizlenir
 */
function SelectedArticles({ fields, operations, form, readOnly = false }) {
  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = fields.findIndex((f) => f.key === active.id);
    const newIndex = fields.findIndex((f) => f.key === over.id);
    if (oldIndex !== -1 && newIndex !== -1) {
      operations.move(oldIndex, newIndex);
    }
  };

  if (fields.length === 0) {
    return (
      <div>
        <h3 className="gx-mb-1">Seçilen Maddeler (0)</h3>
        <EmptyState />
      </div>
    );
  }

  const members = form.getFieldValue('members') ?? [];

  const handleSelectMain = (index) => {
    form.setFieldsValue({ members: markMainMember(members, index) });
  };

  // Ana madde silinirse işaret o an 1. sırada olan maddeye geçer.
  const handleRemove = (index) => {
    const wasMain = members[index]?.isMain;
    operations.remove(index);
    if (!wasMain) return;

    const remainingMembers = form.getFieldValue('members') ?? [];
    if (remainingMembers.length > 0) {
      form.setFieldsValue({ members: markMainMember(remainingMembers, 0) });
    }
  };

  return (
    <div>
      <h3 className="gx-mb-1">Seçilen Maddeler ({fields.length})</h3>
      <div style={{ maxHeight: 300, overflowY: 'auto' }}>
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={fields.map((f) => f.key)}
            strategy={verticalListSortingStrategy}
          >
            {fields.map((field, index) => {
              const member = members[index];
              const statusLabel = (isSharedIdentificationFeatureEnabled && OFFER_STATUS[member?.status]) || null;
              return (
                <SortableItem
                  key={field.key}
                  id={field.key}
                  label={member?.label}
                  articleId={member?.id}
                  readOnly={readOnly}
                  showMainMember={isSharedIdentificationFeatureEnabled}
                  isMain={Boolean(member?.isMain)}
                  statusLabel={statusLabel}
                  onSelectMain={() => handleSelectMain(index)}
                  onRemove={() => handleRemove(index)}
                />
              );
            })}
          </SortableContext>
        </DndContext>
      </div>
    </div>
  );
}

export default SelectedArticles;
